$(document).ready(function () {
	let $formContest = $("#form-contest");
	let formContestDraggedPhoto;
	let $uploadArea = $formContest.find('.upload-photo-area.upload');
	let $uploadedArea = $formContest.find('.upload-photo-area.uploaded');
	let $uploadPhotoInput = $formContest.find("#upload-photo");

	$formContest.submit(function () {
		let route = $(this).attr('action');
		let formData = new FormData(this);
		let $resultMsg = $(this).find('.msg');
		let $btn = $(this).find('button[type=submit]');

		$btn.attr('disabled', 'disabled').text('Отправляем...');

		if (formContestDraggedPhoto) {
			formData.append('photo_dragged', formContestDraggedPhoto);
		}

		$.ajax({
			url: route,
			type: 'POST',
			data: formData,
			success: function (data) {
				if (!data.error) {
					location.reload();
				} else {
					$resultMsg.addClass('text-danger').html(data.msg).show();
					$btn.removeAttr('disabled').text('Отправить');
				}
			},
			cache: false,
			contentType: false,
			processData: false
		});

		return false;
	});

	$uploadPhotoInput.on('input file-selected', function (e) {
		$uploadArea.removeClass('dragenter').hide();
		$uploadedArea.show();
	});

	$uploadArea.on('dragenter', function (e) {
		e.preventDefault();
		$uploadArea.addClass('dragenter');
	});
	$uploadArea.on('dragleave', function (e) {
		e.preventDefault();
		$uploadArea.removeClass('dragenter');
	});
	$uploadArea.on('dragover', function (e) {
		e.preventDefault();
	});
	$uploadArea.on('drop', function (e) {
		e.preventDefault();
		$uploadArea.removeClass('dragenter');
		$uploadPhotoInput.trigger('file-selected');
		formContestDraggedPhoto = e.originalEvent.dataTransfer.files[0];
		return false;
	});
	$uploadedArea.find('.btn-clear').click(function () {
		$uploadedArea.hide();
		$uploadArea.show();
		$uploadPhotoInput.val('');
		return false;
	});
});